module.exports = "//cdn.mxpnl.com/static/asset-cache/c4cc85b3e8ff3a6dba2ba2caa14f799c/iron/common/widgets/demo-selector-modal/assets/icons/Other.svg";